import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-950 text-slate-400" data-testid="auth-loading">
        Wird geladen…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
